<script type="text/jsx" lang="jsx">
import { createEditDeltaComponent } from '@/components/edit-delta-factory';
import mxPlanCommon from '@/plans/WEBINAR/mixin';
import { planTypes } from '@/common/constants';

export default {
  ...createEditDeltaComponent({
    name: 'EditDelta',
    planType: planTypes.WEBINAR,
    mixin: mxPlanCommon,
    withReplenish: true,
    className: 'opc-webinar-edit',
    hideConfigDescription: true,
  }),
  data() {
    return {
      title: this.$t('billing.webinar.title'),
      viewCurrentDialog: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.opc-webinar-edit {
  &__preview-payment {
    margin-top: 24px;
  }
}
</style>
